import { __assign } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import SvgIcon from './SvgIcon';

var Copy = function Copy(props) {
  return _jsxs(SvgIcon, __assign({}, props, {
    children: [_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10.2 1.70007C9.09538 1.70007 8.19995 2.5955 8.19995 3.70007V4.50007H9.79995V3.70007C9.79995 3.47916 9.97904 3.30007 10.2 3.30007L13.7 3.30007V7.50012C13.7 8.49423 14.5058 9.30012 15.5 9.30012H19.7V17.0001C19.7 17.221 19.5209 17.4001 19.3 17.4001H17.5V19.0001H19.3C20.4045 19.0001 21.3 18.1046 21.3 17.0001V8.83144C21.3 8.4071 21.1314 8.00013 20.8313 7.70007L15.3 2.1687C14.9999 1.86864 14.5929 1.70007 14.1686 1.70007H10.2ZM18.5686 7.70012L15.3 4.43144V7.50012C15.3 7.61058 15.3895 7.70012 15.5 7.70012H18.5686Z"
    }), _jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M8.66858 6.20007L4.69995 6.20008C3.59538 6.20009 2.69995 7.09552 2.69995 8.20008V20.0001C2.69995 21.1046 3.59538 22.0001 4.69995 22.0001H13.8C14.9045 22.0001 15.8 21.1046 15.8 20.0001V13.3314C15.8 12.9071 15.6314 12.5001 15.3313 12.2001L9.79995 6.6687C9.49989 6.36864 9.09293 6.20007 8.66858 6.20007ZM4.69995 7.80008L8.19995 7.80007V12.0001C8.19995 12.9942 9.00584 13.8001 9.99995 13.8001H14.2V20.0001C14.2 20.221 14.0209 20.4001 13.8 20.4001H4.69995C4.47904 20.4001 4.29995 20.221 4.29995 20.0001V8.20008C4.29995 7.97917 4.47904 7.80008 4.69995 7.80008ZM9.79995 12.0001V8.93144L13.0686 12.2001H9.99995C9.88949 12.2001 9.79995 12.1106 9.79995 12.0001Z"
    })]
  }));
};

export default Copy;